import React from 'react'

export const Footer: React.FC = () => {
  return (
    <div style={{marginTop: '100px'}}>
      <div className='container_footer'>
        <div className='footer'>
          <ul>
            <li>Разместить объявление</li>
            <li>Объявления</li>
            <li>Помощь</li>
            <li>Безопасность</li>
            <li>Реклама на сайте </li>
            <li>О компании </li>
            <li>Карьера</li>
            <li>GrozShop Журнал </li>
            <li>Блог</li>
            <li>Мобильное приложение</li>
          </ul>
        </div>
        <div className='basement'></div>
        <p>GroznyShop — Продукт от Онлайн-маркета Грозный, аналог сайта объявлении (Авито). © ООО «GrozMarketShop Corporation» 2022–2023.</p>
      </div>
    </div>

  )
}

